import React from "react";
import { Box, Button, Card, Center, Text, TextInput } from "@mantine/core";

export default function ChartAnalytics() {
  return (
    <Card shadow="sm" radius="md" p="xl">
      <Center
        style={{ height: 200, backgroundColor: "#f3f0ff", borderRadius: 8 }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Text size="lg" mb={8}>
            📈 Interactive charts and analytics would be displayed here
          </Text>
          <Text size="sm">
            • Organization performance metrics
            <br />
            • Employee productivity trends
            <br />
            • Project completion rates
            <br />• System usage statistics
          </Text>
        </Box>
      </Center>
    </Card>
  );
}
